import { RegisterUserAccountCommand } from '@generated/api';
import { RegisterAccountCredentials } from '@typeDefs/domain/auth';

/**
 * Maps domain RegisterAccountCredentials to API RegisterAccountCommand.
 */
export const authMapper = {
  toApi(credentials: RegisterAccountCredentials): RegisterUserAccountCommand {
    return {
      userName: credentials.userName,
      password: credentials.password,
      firstName: credentials.firstName,
      lastName: credentials.lastName,
      phoneNumber: credentials.phoneNumber,
      businessName: credentials.businessName,
      position: credentials.position,
      companyNumber: credentials.companyNumber,
      challengeId: credentials.challengeId,
    };
  },
};
